// export default {
//   api: 'http://localhost:3000'
// }
const config = require('./_' + process.env.NODE_ENV);
module.exports = config